<div class="app-bar">
  <div class="container">
    <div class="row">
      <div class="col-xs-1 col-4 app-bar__left"></div>
      <div class="col-xs-10 col-4 app-bar__title">
        {{ appService.appTitle$ | async }}
      </div>
      <div class="col-xs-1 col-4 app-bar__right">
        <span class="app-bar__user">{{ userFullName }}</span>
        <a (click)="logout()"  class="app-bar__button app-bar__button--logout"><span class="app-bar__button-text">Logout</span></a>
      </div>
    </div>
  </div>
</div>
<div class="container container--has-appbar">
  <div class="row">
    <div class="col-lg-8 order-2 order-lg-1">
      <div class="card team-reports">
        <h1 class="card__title">Orders this month</h1>
        <div class="team-reports__reports">
          <div class="team-reports__report">
            <div class="team-reports__icon team-reports__icon--bank"></div>
            <div class="team-reports__value">
              <p class="team-reports__display-quantity">84</p>
              <p class="team-reports__display-label">invoiced</p>
            </div>
          </div>
          <div class="team-reports__report">
            <div class="team-reports__icon team-reports__icon--timer"></div>
            <div class="team-reports__value">
              <p class="team-reports__display-quantity">5</p>
              <p class="team-reports__display-label">to handle</p>
            </div>
          </div>
          <div class="team-reports__report">
            <div class="team-reports__icon team-reports__icon--alert"></div>
            <div class="team-reports__value">
              <p class="team-reports__display-quantity">240</p>
              <p class="team-reports__display-label">created</p>
            </div>
          </div>
          <div class="team-reports__report">
            <div class="team-reports__icon team-reports__icon--package"></div>
            <div class="team-reports__value">
              <p class="team-reports__display-quantity">125</p>
              <p class="team-reports__display-label">goods issued</p>
            </div>
          </div>
          <div class="team-reports__report">
            <div class="team-reports__icon team-reports__icon--truck"></div>
            <div class="team-reports__value">
              <p class="team-reports__display-quantity">95</p>
              <p class="team-reports__display-label">transport arranged</p>
            </div>
          </div>
        </div>
        <div class="team-reports__comment">
          This graph is only meant for demo purposes, and does not reflect actual data
        </div>
      </div>
    </div>
    <div class="col-lg-4 order-1 order-lg-2">
      <div class="greeter">
        <h1 class="greeter__title">{{ humanizedGreeting }}, {{ userFirstName }}!</h1>
        <p class="greeter__date">{{ formattedDate }}</p>
      </div>
      <div class="card my-apps">
        <h1 class="card__title">My apps</h1>
        <div class="my-apps__apps">
          <a class="my-apps__app"
             [href]="application.api_uri"
             target="_blank"
             *ngFor="let application of (authorizedApplications$ | async)">
            <span class="my-apps__app-icon" [ngClass]="remapAppIcon(application.app_id)"></span>
            <span class="my-apps__app-title">{{ application.app_label }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
